var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup46(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 3H0V0H24V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 4 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 9H0V6H24V9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 4 (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 15H0V12H24V15Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup46);
export default __webpack_public_path__ + "static/media/Group 46.a6cd4e5123a48bbafb45653e177a7d41.svg";
export { ForwardRef as ReactComponent };